import { useContext, forwardRef } from 'react';
import classnames from 'classnames';

import { BaseUploadInput } from '..';
import { BaseFormFieldWrapper } from '../BaseFormFieldWrapper/BaseFormFieldWrapper';
import { RequestContext } from '../../context/Request.context';

import './BaseUploadBox.scss';

const BaseUploadBox_ = forwardRef((props, ref) => {
  const { title, conditions, className, basic, type, config, value, isRenewal, isCodeOfConduct, ...rest } = props;

  const classes = classnames('base-upload-box', className, {
    'base-upload-box--no-style': basic,
    'base-upload-box--renewal': isRenewal,
  });

  const { formRef, saveStep, request, url } = useContext(RequestContext);

  const beforeUpload = () => {
    let { case_id, companies } = request;
    if (!case_id) {
      let payload = { companies };
      if (url === 'prospectuses') {
        payload = request;
      }

      payload = { ...payload, ...formRef.current.values };

      try {
        saveStep(payload);
        return true;
      } catch (e) {
        return Promise.reject();
      }
    }
  };

  return (
    <>
      <div className={classes}>
        <p className="copy copy--color-dark copy--bold base-upload-box__title">{title}</p>
        <p className="copy copy--small base-upload-box__conditions">{conditions}</p>

        <BaseUploadInput
          ref={ref}
          outline={basic}
          type={type}
          config={config}
          uploadingFiles={value}
          beforeUpload={beforeUpload}
          isRenewal={isRenewal}
          isCodeOfConduct={isCodeOfConduct}
          {...rest}
        />
      </div>
    </>
  );
});

BaseUploadBox_.displayName = 'BaseUploadBox';

export const BaseUploadBox = BaseFormFieldWrapper(BaseUploadBox_);
export default BaseUploadBox;
